
interface TabBarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export default function TabBar({ activeTab, setActiveTab }: TabBarProps) {
  const navigate = useNavigate();

  const tabs = [
    { id: 'home', name: 'الرئيسية', icon: 'ri-home-line', activeIcon: 'ri-home-fill' },
    { id: 'auctions', name: 'المزادات', icon: 'ri-auction-line', activeIcon: 'ri-auction-fill' },
    { id: 'add', name: 'إضافة', icon: 'ri-add-circle-line', activeIcon: 'ri-add-circle-fill', isSpecial: true },
    { id: 'favorites', name: 'المفضلة', icon: 'ri-heart-line', activeIcon: 'ri-heart-fill' },
    { id: 'profile', name: 'الملف', icon: 'ri-user-line', activeIcon: 'ri-user-fill' }
  ];

  const handleTabClick = (tabId: string) => {
    if (tabId === 'add') {
      navigate('/add-listing');
    } else {
      setActiveTab(tabId);
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black/90 backdrop-blur-sm border-t border-gray-800">
      <div className="grid grid-cols-5 h-16">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`flex flex-col items-center justify-center space-y-1 transition-colors ${
              tab.isSpecial 
                ? 'text-yellow-400' 
                : activeTab === tab.id 
                  ? 'text-yellow-400' 
                  : 'text-gray-400 hover:text-white'
            }`}
          >
            <i className={`${activeTab === tab.id ? tab.activeIcon : tab.icon} text-xl`}></i>
            <span className="text-xs font-medium">{tab.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
